var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qa"},[_c('div',{staticClass:"qa_question"},[_c('div',{staticClass:"qa_question-number"},[_vm._v(_vm._s(_vm.qa.numberQuestion))]),_c('div',{staticClass:"qa_question-question"},[_vm._v(" "+_vm._s(_vm.qa.question)+" ")])]),_c('div',{staticClass:"qa_answer",domProps:{"innerHTML":_vm._s(_vm.qa.answer)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }